import ProgressBar from './ProgressBar'
import Grid from './Grid'
import {useEffect, useMemo, useRef, useState} from 'react'
import VideoModal from './VideoModal'
import Search from './Search'
import SearchResult from './SearchResult'
import {buildWorksheetUrl, createArrayWithEmptyCells} from '../util/helpers'
import {gridCellOptions} from '../util/constants'
import ShareControls from './ShareControls'
import SelectWrapper from './SelectWrapper';

const initialSteps = [
  { id: 1, name: Drupal.t('Grid layout'), href: '#', status: 'current' },
  { id: 2, name: Drupal.t('Words'), href: '#', status: 'upcoming' },
  { id: 3, name: Drupal.t('Sharing'), href: '#', status: 'upcoming' },
]

export default function Worksheets() {
  const [steps, setSteps] = useState(initialSteps)
  const currentStepId = useMemo(
    () => steps.find(step => step.status === 'current').id,
    [steps]
  )
  const [grid, setGrid] = useState(createArrayWithEmptyCells)
  const [tokens, setTokens] = useState([])
  const [domainLabel, setDomainLabel] = useState('')
  const [domainOptions, setDomainOptions] = useState({})
  const [alphabet, setAlphabet] = useState({
    letters: [],
    active: [],
  })
  const worksheetUrl = useMemo(
    () => buildWorksheetUrl(grid),
    [grid]
  )
  const shareableGridRef = useRef(null)

  useEffect(() => {
    setDomainLabel(drupalSettings.worksheets.domain.label)
    setDomainOptions(drupalSettings.worksheets.domain.options)
    setAlphabet(drupalSettings.worksheets.alphabet)
  }, [])

  const changeCurrentStep = (id) => {
    let found = false

    setSteps(steps.map((step) => {
      if (!found) {
        step.status = 'complete'
      }

      if (step.id === id) {
        step.status = 'current'
        found = true

        return step
      }

      if (found) {
        step.status = 'upcoming'
      }

      return step
    }))
  }

  const resetGrid = (count) => {
    setGrid(createArrayWithEmptyCells(count))
  }

  const addTokenToGrid = (token) => {
    const index = grid.findIndex((c) => c === null)

    if (index !== -1 && token) {
      setGrid(grid.map((c, i) => {
        if (i === index) {
          return token
        }

        return c
      }))
    }
  }

  return (
    <>
      <ProgressBar steps={steps} changeCurrentStep={changeCurrentStep} />
      <div>
        {currentStepId === 1 && (
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-semibold mb-4">{Drupal.t('Choose grid layout')}</h2>
            <div>
              <label htmlFor="cells" className="block text-sm/6 font-medium text-gray-900">{Drupal.t('Grid')}</label>
              <div className="mt-2 grid grid-cols-1 mb-8">
                <SelectWrapper>
                  <select id="cells" name="cells" value={grid.length}
                          onChange={e => resetGrid(parseInt(e.target.value))}
                          className="block w-full rounded-md bg-white px-3 py-2 text-base text-gray-900 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-600">
                    {gridCellOptions.map((item, index) => (
                      <option value={item.count} key={index}>{item.text}</option>
                    ))}
                  </select>
                </SelectWrapper>
              </div>
            </div>
            <Grid grid={grid} setGrid={setGrid} />
            <div className="flex flex-row justify-end gap-2 mt-8">
              <button className="bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter"
                      onClick={() => changeCurrentStep(currentStepId + 1)}>{Drupal.t('Next')}</button>
            </div>
          </div>
        )}

        {currentStepId === 2 && (
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-semibold mb-4">{Drupal.t('Add words to the grid')}</h2>
            <Search domainLabel={domainLabel} domainOptions={domainOptions} tokens={tokens} setTokens={setTokens} alphabet={alphabet}>
              {tokens.length > 0 && (
                <div className="flex flex-wrap justify-start gap-2 mb-4">
                  {tokens.map((token, index) => (
                    <SearchResult isInGrid={grid.findIndex((current) => current && current.id === token.id) !== -1}
                                  key={index} addTokenToGrid={() => addTokenToGrid(token)}>{token.title}</SearchResult>
                  ))}
                </div>
              )}
            </Search>
            <Grid grid={grid} setGrid={setGrid} displayActions={true} />
            <div className="flex flex-row justify-end gap-2 mt-8">
              <button className="bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter"
                      onClick={() => changeCurrentStep(currentStepId + 1)}>{Drupal.t('Next')}</button>
            </div>
          </div>
        )}

        {currentStepId === 3 && (
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl font-semibold mb-4">{Drupal.t('Share word grid')}</h2>
            <Grid grid={grid} setGrid={setGrid} ref={shareableGridRef} />
            <ShareControls worksheetUrl={worksheetUrl} shareableGridRef={shareableGridRef} />
          </div>
        )}

        <VideoModal />
      </div>
    </>
  )
}
